import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["symbolSelect", "positionSelect"];

  connect() {
    this.applyDefaultPosition();
  }

  updateSymbolPosition(event) {
    const symbol = event?.target?.value || this.symbolSelectTarget.value;
    
    const defaultPosition = this.defaultPositionFor(symbol);
    
    // Update hidden field if it exists
    const hiddenField = this.element.querySelector('input[type="hidden"][name*="number_symbol_position"]');
    if (hiddenField) {
      hiddenField.value = defaultPosition;
    }
    
    // Also update select if it exists (for backwards compatibility)
    if (this.hasPositionSelectTarget) {
      this.positionSelectTarget.value = defaultPosition;
    }
  }

  applyDefaultPosition() {
    if (!this.hasSymbolSelectTarget) return;

    const symbol = this.symbolSelectTarget.value;
    const defaultPosition = this.defaultPositionFor(symbol);
    
    // Update hidden field if it exists
    const hiddenField = this.element.querySelector('input[type="hidden"][name*="number_symbol_position"]');
    if (hiddenField && hiddenField.value === "") {
      hiddenField.value = defaultPosition;
    }
    
    // Also update select if it exists (for backwards compatibility)
    if (this.hasPositionSelectTarget && this.positionSelectTarget.value === "") {
      this.positionSelectTarget.value = defaultPosition;
    }
  }

  defaultPositionFor(symbol) {
    const frontSymbols = ["$", "£", "€", "¥"];
    return frontSymbols.includes(symbol) ? "front" : "back";
  }
}
